import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

// The top-bar notification bell (first consumer: Payroll Requests - approvers are notified of
// new submissions; submitters of decisions and applies). Per-user data, no feature gate.

export interface INotification {
    id: number;
    type: string;
    title: string;
    body?: string | null;
    linkUrl?: string | null;
    createdOn: string;
    readOn?: string | null;
}

export interface INotificationList {
    unreadCount: number;
    items: INotification[];
}

@Injectable({ providedIn: 'root' })
export class NotificationsService {

    private base = `${environment.adminApiUrl}/notifications`;

    // Live unread count for the bell badge (updated by every mine() fetch).
    public readonly unreadCount$ = new BehaviorSubject<number>(0);

    constructor(private httpClient: HttpClient) { }

    public mine(): Observable<INotificationList> {
        return this.httpClient.get<INotificationList>(`${this.base}/mine`).pipe(
            tap(list => this.unreadCount$.next(list?.unreadCount ?? 0))
        );
    }

    public markRead(id: number): Observable<void> {
        return this.httpClient.put<void>(`${this.base}/${id}/read`, null);
    }

    public markAllRead(): Observable<{ marked: number }> {
        return this.httpClient.put<{ marked: number }>(`${this.base}/read-all`, null);
    }
}
